'use client';

import { ArrowLeft } from '@depop/web-thrift-ui/Icons/ArrowLeft';
import { ArrowRight } from '@depop/web-thrift-ui/Icons/ArrowRight';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { type NavigationState } from '.';

export function NavButtons({
  hideOnMobile = false,
  navigationState,
}: {
  hideOnMobile?: boolean;
  navigationState: NavigationState;
}) {
  const t = useTranslations('common');
  return (
    <div className={clsx(styles.arrowsWrap, hideOnMobile && styles.mobile)}>
      <button
        type="button"
        aria-label={t('Previous')}
        onClick={navigationState.goLeft}
        disabled={!navigationState.canGoLeft}
        className={clsx(
          styles.arrowBtn,
          !navigationState.canGoLeft && styles.arrowBtnDisabled
        )}
      >
        <ArrowLeft size="sm" />
      </button>

      <button
        type="button"
        aria-label={t('Next')}
        onClick={navigationState.goRight}
        disabled={!navigationState.canGoRight}
        className={clsx(
          styles.arrowBtn,
          !navigationState.canGoRight && styles.arrowBtnDisabled
        )}
      >
        <ArrowRight size="sm" />
      </button>
    </div>
  );
}
